import { Component } from '@angular/core';
import { IzzyChannelTypeActionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Channel Type Actions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzychanneltypeaction-form',
    templateUrl: './izzychanneltypeaction.form.component.html'
})
export class IzzyChannelTypeActionFormComponent extends BaseFormComponent {
    public record!: IzzyChannelTypeActionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'referenceData', sectionName: 'Reference Data', isExpanded: true },
            { sectionKey: 'actionConfiguration', sectionName: 'Action Configuration', isExpanded: true },
            { sectionKey: 'credentialSettings', sectionName: 'Credential Settings', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

